'use client'

interface SpinnerProps {
  /** Size of the spinner: 'sm' (16px), 'md' (20px), 'lg' (32px), 'xl' (48px) */
  size?: 'sm' | 'md' | 'lg' | 'xl'
  /** Color class for the spinner (e.g., 'text-primary', 'text-white', 'text-gray-500') */
  color?: string
  /** Additional CSS classes */
  className?: string
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-8 w-8',
  xl: 'h-12 w-12',
}

export function Spinner({ size = 'md', color = 'text-primary', className = '' }: SpinnerProps) {
  return (
    <svg
      className={`animate-spin ${sizeClasses[size]} ${color} ${className}`}
      fill="none"
      viewBox="0 0 24 24"
      data-component-name="Spinner"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  )
}
